import {useQuery} from "@tanstack/react-query";
import getBanners from "../services/banners/getBanners.service";

const useGetBannerList = () => {
  const {data, isError, isLoading, isSuccess, refetch, error} = useQuery({
    queryKey: ["homeBanners"],
    queryFn: getBanners,
  });

  return {
    data: data?.data?.data,
    isError,
    isLoading,
    isSuccess,
    refetch,
    error,
  };
};

export default useGetBannerList;
